
// ----------------------------------------------------------------------

export type IPaymentCard = {
  id: string;
  cardNumber: string;
  cardType: string;
  primary?: boolean;
};

export enum RecruiterPlans {
  Free = 'recruiter_free',
  AgencyStartup = 'recruiter_agency_startup',
  AgencySmall = 'recruiter_agency_small',
  AgencyMedium = 'recruiter_agency_medium',
  AgencyLarge = 'recruiter_agency_large',
  AgencyXL = 'recruiter_agency_xl',
  AgencyPremium = 'recruiter_agency_premium',
  Basic = 'recruiter_basic',
  SubTenantStandard = 'recruiter_sub_tenant_standard',
  MeetingLicenseAddon = 'recruiter_meeting_license_addon',
}

export enum ClientPlans {
  Free = 'client_free',
  Basic = 'client_basic',
  BusinessStartup = 'client_business_startup',
  BusinessSmall = 'client_business_small',
  BusinessMedium = 'client_business_medium',
  BusinessLarge = 'client_business_large',
  BusinessXL = 'client_business_xl',
  SubTenantStandard = 'client_sub_tenant_standard',
  SubTenantAddon = 'client_subtenant_addon',
  SeatSmallAddon = 'client_seat_small_addon',
  SeatLargeAddon = 'client_seat_large_addon',
  MeetingLicenseAddon = 'client_meeting_license_addon',
}

export enum CandidatePlans {
  Free = 'candidate_free',
  Pro = 'candidate_pro',
}

export enum PayPeriod {
  Monthly = 'month',
  Yearly = 'year',
}